import React from "react";
import SelectPrimitive from "react-select";
import "./styles.css"

type T_props = {} & React.ComponentPropsWithoutRef<typeof SelectPrimitive>;

export const Select = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive>,
  T_props
>((props, ref) => {
  return <SelectPrimitive ref={ref} {...props} classNamePrefix='react-select' />;
});